// Copyright (c) 2017 Deere & Company

import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import DealerHierarchyTerritory from '@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy-territory';
import {getDefaultState as getDefaultDateRangeState} from './date-range';
import t from 'tcomb';

const Criteria = t.struct({
    originalSubmissionDate: DateRange,
    selectedTerritories: t.list(DealerHierarchyTerritory)
}, 'Criteria');

export const getDefaultState = () =>
    new Criteria({
        originalSubmissionDate: getDefaultDateRangeState(),
        selectedTerritories: []
    });

export default Criteria;



// WEBPACK FOOTER //
// ./src/reports/special-allowance-claim-status/state/criteria.js